export const THEME_PROVIDER_CATEGORY_KEY = 'base' as const;
export const THEME_PROVIDER_COMPONENT_KEY = 'themeProvider' as const;
